import React from "react";

const renderContent = (text) => {
    if (!text) return null;
    const parts = text.split(/\*\*(.+?)\*\*/g);
    return parts.map((part, i) =>
        i % 2 === 1 ? <strong key={i}>{part}</strong> : part
    );
};

const ChatMessage = ({ message }) => (
    <div className={`chat-bubble ${message.role}`}>
        {renderContent(message.content)}
    </div>
);

export default ChatMessage;
